import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export const DEFAULT_CONTACT = {
  email: "infantsleepconsultantnearme@gmail.com",
  phone: "720-926-3037",
};

let cache = null;

export async function fetchContact() {
  if (cache) return cache;
  try {
    const { data } = await http.get("/settings/contact");
    cache = { email: data.email || DEFAULT_CONTACT.email, phone: data.phone || DEFAULT_CONTACT.phone };
  } catch (e) {
    cache = DEFAULT_CONTACT;
  }
  return cache;
}

export function telHref(phone) {
  const d = (phone || "").replace(/[^0-9]/g, "");
  return "tel:+" + (d.length === 10 ? "1" + d : d);
}

export function useContact() {
  const [c, setC] = useState(cache || DEFAULT_CONTACT);
  useEffect(() => { fetchContact().then(setC); }, []);
  return c;
}
